import React from 'react';

import { ReactComponent as WarningRed } from 'assets/icons/warning-red.svg';
import { Modal } from 'components';
import { deleteGroup, deleteUser } from 'store/adminPanel/actions';
import { useDispatch } from 'react-redux';
import { Button } from 'antd';

const DeleteModal = ({ isVisible, setVisible, selectedLocals, setSelectedLocals}) => {
  const dispatch = useDispatch();
  
  const handleOk = () => {
    selectedLocals.map(item => dispatch(deleteGroup(item)));
    setSelectedLocals([]);
    setVisible(false);
  };

  return (
    <Modal
      isVisible={isVisible}
      Icon={WarningRed}
      width={400}
      title={<h1 style={{color:"#EB5757", marginTop:"0.563rem", marginLeft:"1rem"}}>Delete</h1>}
      okText="Delete"
      footer={
        <div style={{display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px"}}>
          <Button
            onClick={() => setVisible(false)}
            className="default-button"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {setVisible(false); handleOk()}}
            className="primary-button"
          >
            Delete
          </Button>
        </div>
      }
      className={'invalid-modal'}
    >
      <div className="invalid-modal__body">
        Είστε βέβαιοι ότι επιθυμείτε να διαγράψετε τα επιλεγμένα locals;
      </div>
    </Modal>
  );
};

export default DeleteModal;